import { giphyBlue, giphyWhite } from '@giphy/js-brand'
import { trim } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { IChannel } from 'shared/types/channel'
import styled, { keyframes } from 'styled-components'
import { CollectionContext } from '..'
import { AddToCollectionContext } from './context'

const showCrumbs = keyframes`
    0% { 
        opacity: 0;
    }
    100% { 
        opacity: 1;
    }
`
const Container = styled.div`
    width: 100%;
    display: flex;
    background: black;
    color: ${giphyBlue};
    padding: 12px 27px;
    font-style: italic;
    cursor: pointer;

    .ss-navigateleft {
        margin-right: 10px;
        color: ${giphyWhite};
    }
    animation: ${showCrumbs} 0.3s ease-out forwards;
`

const Crumbs = styled.div`
    display: flex;
    white-space: nowrap;
    cursor: pointer;
`

const Slash = styled.span`
    color: ${giphyWhite};
    padding: 0 5px;
`

export const singleColumnNumberOfCrumbs = 2

type Props = {
    channel: IChannel
    // the max legnth of each crumb
    maxCrumbLength?: number
    // the max number of crumbs to show at once
    numberOfCrumbs?: number
    // show root as crumb
    showRoot?: boolean
}
const Breadcrumbs = ({ channel, maxCrumbLength = 25, numberOfCrumbs = 4, showRoot }: Props) => {
    const { channels } = useContext(CollectionContext)
    const { setActiveChannelId } = useContext(AddToCollectionContext)
    const [breadcrumbs, setBreadcrumbs] = useState<IChannel[]>([])
    useEffect(() => {
        const getCrumbs = (channel: IChannel, crumbs: IChannel[] = []): IChannel[] => {
            const parent = channels[channel.parent]
            if (parent) {
                return [...getCrumbs(parent, crumbs), channel]
            }
            return showRoot ? [channel, ...crumbs] : crumbs
        }
        const crumbs = getCrumbs(channel)
        setBreadcrumbs(crumbs.slice(-numberOfCrumbs))
    }, [channel])
    let slack = 0 // keep track of crumbs' character surplus
    const truncateCrumb = (c: string) => {
        // some combination of limiting items
        if (breadcrumbs.length < numberOfCrumbs) {
            return c
        }
        // and truncation should be enough
        const result = c.length > maxCrumbLength + slack ? trim(c.slice(0, maxCrumbLength)) + '...' : c
        if (c.length < maxCrumbLength) {
            slack += maxCrumbLength - c.length
        }
        return result
    }
    const onBackArrowClick = () => {
        const [firstBreadcrumb] = breadcrumbs
        if (firstBreadcrumb) {
            setActiveChannelId(firstBreadcrumb.id)
        }
    }
    return (
        <Container>
            <Crumbs>
                <div className="ss-navigateleft" onClick={onBackArrowClick} />
                {breadcrumbs.map(({ id, display_name }, index) => {
                    return (
                        <div key={id} onClick={() => setActiveChannelId(id)}>
                            <span>{truncateCrumb(display_name)}</span>
                            {index !== breadcrumbs.length - 1 && <Slash>/</Slash>}
                        </div>
                    )
                })}
            </Crumbs>
        </Container>
    )
}

export default Breadcrumbs
